package ext

import pdflib.RGB
import three.js.Color

val RGB.threeColor get() = Color(red, green, blue)